export const getToken = () => {
  let authData = localStorage.getItem("own-energy-auth");
  if (authData) {
    authData = JSON.parse(authData);
    return authData.user.accessToken;
  }
  return undefined;
};

export const getUser = () => {
  let authData = localStorage.getItem("own-energy-auth");
  if (authData) {
    authData = JSON.parse(authData);
    return authData.user;
  }
  return undefined;
};

export const checkAthenticatedUser = () => {
  let authData = localStorage.getItem("own-energy-auth");
  if (authData) {
    return true;
  }
  return false;
};

export const saveStorage = (user) => {
  let authData = JSON.stringify({ user });
  localStorage.setItem("own-energy-auth", authData);
};

export const removeStorage = () => {
  localStorage.removeItem("own-energy-auth");
};

export const refreshStorage = (user) => {
  let authData = localStorage.getItem("own-energy-auth");
  if (authData) {
    authData = JSON.parse(authData);
    authData.user = user;
    localStorage.setItem("own-energy-auth", JSON.stringify(authData));
  }
};
